module.exports = __webpack_public_path__ + "static/media/ente-1-setup-key.d8872cb4.png";